function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value;
  });
  return vars;
}


function getUrlParam(parameter, defaultvalue) {
  var urlparameter = defaultvalue;
  if (window.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter];
  }
  return urlparameter;
}

var coupon = getUrlParam('code', '');

var anchors = document.getElementsByTagName("a");

for (var i = 0; i < anchors.length; i++) {
  if (anchors[i].href.includes('allaccesspass/register') && anchors[i].href.match(/\//ig).length < 6){
    anchors[i].href = anchors[i].href + '/' + coupon;
  }
}